/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IHome, ICreditRequestsCount } from './homeSlice.types';

const initialState: IHome = {
  // set initial state back to zero when using query
  creditRequestsCount: {
    all: 0,
    approved: 0,
    processing: 0,
    cancelled: 0,
    notSubmitted: 0,
    completed: 0,
    refunded: 0,
    submitted: 0,
    pending: 0,
    success: 0,
    failed: 0
  }
};

export const homeSlice = createSlice({
  name: 'homeSlice',
  initialState,
  reducers: {
    setCreditRequestsCount: (state: IHome, action: PayloadAction<ICreditRequestsCount>) => {
      const { payload } = action;
      state.creditRequestsCount = payload;
    }
  }
});

const { actions, reducer } = homeSlice;
export const { setCreditRequestsCount } = actions;
export default reducer;
